import { useEffect } from 'react';
import { useScript } from 'routes/Util/Util.hooks';

declare const TradingView: { widget: any };

export const Chart = ({ symbol }: { symbol: string }) => {
  const status = useScript('https://s3.tradingview.com/tv.js');

  useEffect(() => {
    if (status === 'ready') {
      new TradingView.widget({
        "autosize": true,
        "symbol": symbol,
        "interval": "D",
        "timezone": "Etc/UTC",
        "theme": "light",
        "style": "1",
        "locale": "kr",
        "toolbar_bg": "#f1f3f6",
        "enable_publishing": false,
        "hide_top_toolbar": true,
        "save_image": false,
        "container_id": "tradingview_fb5a1"
      });
    }

    return () => {
      // Destroy widget. There is no API.
    }
  }, [status, symbol]);

  return (
    <div className="tradingview-widget-container">
      <div id="tradingview_fb5a1"></div>
    </div>
  )
}
